import React from 'react'
import UserForm from './UserForm'
import {Modal} from 'react-bootstrap'


const UserNew = ({show,handleModalClose,handleSubmit}) => (
  <div>
    <Modal show={show} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Neuer Benutzer</Modal.Title>
        </Modal.Header>
          <UserForm
             handleSubmit={handleSubmit}
            />
        </Modal>
  </div>
)

export default UserNew;